"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _default = {
  PropTypes: {
    customProperties: _propTypes.object,
    accessible: _propTypes.bool,
    theme: _propTypes.string,
    handleSelect: _propTypes.func,
    isLoading: _propTypes.bool,
    data: (0, _propTypes.shape)({
      journeyDate: _propTypes.string,
      origin: _propTypes.string,
      destination: _propTypes.string,
      guestNames: (0, _propTypes.arrayOf)(_propTypes.string),
      flightNumber: _propTypes.string,
      bookingNumber: _propTypes.string,
      lastName: _propTypes.string
    })
  },
  DefaultProps: {
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    handleSelect: null,
    data: null,
    isLoading: false
  }
};
exports.default = _default;